import React from 'react';
import { FaClipboardList, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const ItineraryDetails = ({ detailsRef, inclusions, exclusions }) => (
  <div ref={detailsRef} id="details-section" className="inclusions-exclusions-section">
    <h2><FaClipboardList /> Inclusions & Exclusions</h2>
    <div className="details-grid">
      <div className="booking-section">
        <h4>What's Included:</h4>
        <ul className="booking-list included-list">
          {inclusions.map((item, index) => (
            <li key={index}><FaCheckCircle /> {item}</li>
          ))}
        </ul>
      </div>
      <div className="booking-section">
        <h4>What's Not Included:</h4>
        <ul className="booking-list excluded-list">
          {exclusions.map((item, index) => (
            <li key={index}><FaTimesCircle /> {item}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default ItineraryDetails;
